import { IconButton, Menu, MenuGroup } from "@controls";
import { EllipsisVertical } from "@icons";
import { Table as TanStackTable } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { TableAction } from "../interface";

interface TableActionsProps<T> {
  table: TanStackTable<T>;
}

export default function TableActions<T>({ table }: TableActionsProps<T>) {
  const { t } = useTranslation();

  const actions: TableAction<T>[] = (
    table.options.meta && "actions" in table.options.meta
      ? table.options.meta["actions"]
      : []
  ) as TableAction<T>[];

  if (actions.length === 0) {
    return null;
  }

  const selectedRows = table.getSelectedRowModel().rows;

  const toMenuItem = (action: TableAction<T>) => ({
    key: action.key,
    icon: action.icon ?? null,
    label: action.label,
    danger: action.danger,
    disabled: action.isDisabled(selectedRows),
    onSelect: () => {
      const deselect = action.onClick(table.getSelectedRowModel().rows);

      if (deselect) {
        table.setRowSelection({});
      }
    },
  });

  const standardActions = actions.filter((action) => !action.danger);
  const dangerActions = actions.filter((action) => action.danger);

  const groups: MenuGroup[] = [];
  if (standardActions.length > 0) {
    groups.push({
      key: "tableActions",
      items: standardActions.map(toMenuItem),
    });
  }
  if (dangerActions.length > 0) {
    groups.push({
      key: "tableDangerActions",
      items: dangerActions.map(toMenuItem),
    });
  }

  return (
    <Menu
      ariaLabel={t("tableActions")}
      align="end"
      trigger={
        <IconButton
          size="sm"
          icon={<EllipsisVertical />}
          label={t("tableActions")}
          type="button"
        />
      }
      groups={groups}
    />
  );
}
